/* unplugin-vue-components disabled */import script from "./certificatePostAddress.vue?vue&type=script&lang=ts&setup=true"
export * from "./certificatePostAddress.vue?vue&type=script&lang=ts&setup=true"

import "./certificatePostAddress.vue?vue&type=style&index=0&id=59026ea6&lang=less"

export default script